import React from 'react'
import {
    BackButton,
    Bloc,
    Header,
    ProgressBar,
    Conditionnal,
} from '../ImportAll'

export default function Vue0() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Estimez votre crédit immobilier"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={5} time={5} />
            </div>

            <div className="Container">
                {/* Si esquive du choix de type (car preselectionné) */}
                <Conditionnal
                    linked_data_id="tech_esquiver_prj_type"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <Bloc
                        key="key3"
                        selectable
                        linked_data_id="prj_maturite"
                        linked_data_value="RECHERCHE"
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        maturiteStyle
                        logourl="svg/search.svg"
                        text1="Je suis à la recherche de mon bien "
                        text2="Obtenir mon budget et une attestation de capacité d’emprunt. Simulation gratuite."
                        gtm_id="e1-Je suis à la recherche de mon bien"
                    />
                    <Bloc
                        key="key4"
                        selectable
                        linked_data_id="prj_maturite"
                        linked_data_value="TROUVE"
                        targetView={3}
                        nbcolumn={2}
                        droit
                        maturiteStyle
                        logourl="svg/rp.svg"
                        text1="J’ai trouvé mon bien"
                        text2="Obtenir la meilleure simulation de taux. Simulation gratuite."
                        gtm_id="e1-J\'ai trouvé mon bien"
                    />
                </Conditionnal>

                {/* Si on esquive pas le choix de type (car preselectionné) */}

                <Conditionnal
                    linked_data_id="tech_esquiver_prj_type"
                    isNotEqualTo
                    targetDataValueCompare={true}
                >
                    <Bloc
                        key="key3"
                        selectable
                        linked_data_id="prj_maturite"
                        linked_data_value="RECHERCHE"
                        targetView={2}
                        nbcolumn={2}
                        gauche
                        maturiteStyle
                        logourl="svg/search.svg"
                        text1="Je suis à la recherche de mon bien "
                        text2="Obtenir mon budget et une attestation de capacité d’emprunt. Simulation gratuite."
                        gtm_id="e1-Je suis à la recherche de mon bien"
                    />
                    <Bloc
                        key="key4"
                        selectable
                        linked_data_id="prj_maturite"
                        linked_data_value="TROUVE"
                        targetView={2}
                        nbcolumn={2}
                        droit
                        maturiteStyle
                        logourl="svg/rp.svg"
                        text1="J’ai trouvé mon bien"
                        text2="Obtenir la meilleure simulation de taux. Simulation gratuite."
                        gtm_id="e1-J\'ai trouvé mon bien"
                    />
                </Conditionnal>
            </div>
        </div>
    )
}
